import React from "react";
import PropTypes from "prop-types";

import FieldsetStyles from "lib/components/Fieldset/Fieldset.module.scss";
import {renderCurrency} from "lib/utils/CurrencyUtils";
import Fieldset from "lib/components/Fieldset/Fieldset";
import styles from "./Membership.module.scss";
import {__values} from "tslib";

export default class MembershipCostBreakdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      generatingBreakdown: false,
      html: null
    };
    this.parseMemberEnitities = this.parseMemberEnitities.bind(this);
    this.memberEntityCount = this.memberEntityCount.bind(this);
    this.generateBreakdown = this.generateBreakdown.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.members.length != this.props.members.length ||
      nextProps.couponCode != this.props.couponCode ||
      JSON.stringify(nextState.html) !=
      JSON.stringify(this.state.html) ||
      JSON.stringify(nextProps.members) !=
      JSON.stringify(this.props.members)
    );
  }

  componentDidMount() {
    this.generateBreakdown();
  }

  componentDidUpdate(prevProps, prevState) {
    this.generateBreakdown();
  }

  generateBreakdown() {
    this.setState({generatingBreakdown: true});
    $.ajax({
      url: `/api/membership_products/${this.props.product.id}/pricing_calculations/`,
      dataType: "json",
      type: "POST",
      data: JSON.stringify({
        pricing_calculation: {
          coupon_code: this.props.couponCode,
          member_entities: this.parseMemberEnitities()
        }
      }),
      headers: {
        "cache-control": "no-cache",
        Accept: "application/json;version=3",
        "Content-Type": "application/json",
        "X-ClubZap-App-Id": "ClubZapWebsite"
      },
      success: data => {
        this.setState({
          html: data.html,
          generatingBreakdown: false
        });
      },
      error: (xhr, status, err) => {
        this.setState({generatingBreakdown: false});
      }
    });
  }

  parseMemberEnitities() {
    return this.props.memberEntities.map(entity => ({
      id: entity.id,
      count: this.memberEntityCount(entity)
    })).filter(el => el.count > 0);
  }

  memberEntityCount(entity) {
    return this.props.members.filter(member => member?.entity?.id === entity.id)
      .length;
  }

  innerHTML() {
    if (this.state.generatingBreakdown || !this.state.html) {
      return <p>Pending...</p>;
    } else {
      return <div dangerouslySetInnerHTML={{__html: this.state.html}}/>;
    }
  };

  render() {
    const clubId = this.props.clubId;
    return (
      <div className="member_fields">
        <Fieldset legend="Order Summary">
          <div className={styles.breakdownSummary}>{this.innerHTML()}</div>
        </Fieldset>
      </div>
    );
  }
}

MembershipCostBreakdown.propTypes = {
  product: PropTypes.object.isRequired,
  couponCode: PropTypes.string,
  members: PropTypes.arrayOf(PropTypes.object).isRequired,
  memberEntities: PropTypes.arrayOf(PropTypes.object).isRequired,
  showBreakdown: PropTypes.bool.isRequired
};
